/**
 * @ngdoc component
 * @name westBerkshireEvents.readableDatetime:wbReadableDatetime
 * 
 * @description 
 * This component uses a template to recreate a readbable datetime
 */

import readableDatetimeTemplate from './readable_datetime.template.html';

angular.module('westBerkshireEvents.readableDatetime').component('wbReadableDatetime', {
    templateUrl: readableDatetimeTemplate.id,
    controller: ['$scope', WbReadableDatetimeController],
    controllerAs: "$readableDatetimeCtrl",
    bindings: {
        booking: '<'
    } 
});

function WbReadableDatetimeController($scope) {
    const self = this;
    self.booking = this.booking;
} 



// WEBPACK FOOTER //
// src/public/javascripts/readable-datetime/readable_datetime.component.js